import { InfoDialog } from "./InfoDialog";
import { Wordmark } from "./AppHeader";
import { useIntroStore } from "../state/introStore";

/**
 * The one-time, first-visit explanation (GRA-137, from the 2026-09-07 product
 * review): what the game is, what a round asks, and that the Instrument stays
 * anonymized until reveal. Reads `introStore`, so it renders nothing once
 * dismissed, this render or any later one. Deliberately not a landing page:
 * one short dialog, over the real UI, never blocking anything after the first
 * dismissal.
 */
export function IntroOverlay() {
  const dismissed = useIntroStore((s) => s.dismissed);
  const dismiss = useIntroStore((s) => s.dismiss);

  if (dismissed) return null;

  return (
    <InfoDialog title={<Wordmark />} size="wide" closeLabel="got it" onClose={dismiss}>
      <p>
        A chart-reading trainer. Each round is a slice of a real market&rsquo;s
        price history (futures, stocks, or crypto), shown with no instrument
        name, no dates and no price labels.
      </p>
      <p>Three ways to play:</p>
      <ul className="list-disc space-y-1 pl-5">
        <li>
          <span className="text-accent">Predict</span>: call which barrier
          price reaches first, Higher or Lower.
        </li>
        <li>
          <span className="text-accent">Trade</span>: place a simulated
          entry, stop and target. No real money involved.
        </li>
        <li>
          <span className="text-accent">Challenge</span>: ten shared rounds a
          day, the same for every player.
        </li>
      </ul>
      <p>
        After each round the chart plays forward and shows the instrument,
        the dates and how it played out.
      </p>
    </InfoDialog>
  );
}
